import React, { useRef, useEffect } from 'react';
import QRCode from 'qrcode';

const SimpleQR = ({ value, size = 200 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!value || !canvasRef.current) return;

    // Generar QR directamente en el canvas
    QRCode.toCanvas(
      canvasRef.current,
      value,
      {
        width: size,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      },
      (error) => {
        if (error) {
          console.error('Error generating QR:', error);
        }
      }
    );
  }, [value, size]);

  return <canvas ref={canvasRef} style={{ width: size, height: size }} />;
};

export default SimpleQR;
